import classNames from 'classnames'
import { useState } from 'react'

import type { ICellRendererParams } from 'ag-grid-community'
import type { ReactElement } from 'react'
import type { IRecommendedClusterList } from '~/types/cluster'

import RadioInput from '~/components/Inputs/Basic/RadioInput'

import './styles.scss'

export const RECOMMENDATION_LOCAL_STORAGE = 'recommended-cluster'

const ClusterDecisionCellRenderer = ({ context, data }: ICellRendererParams<IRecommendedClusterList>): ReactElement => {
  const { onDecisionCheckboxChange } = context

  const { app, current_clusters, recommended_clusters } = data as IRecommendedClusterList

  const [selectedCluster, setSelectedCluster] = useState<string | null>(
    JSON.parse(localStorage.getItem(RECOMMENDATION_LOCAL_STORAGE) || '{}')[app.store_id]
  )

  const checkboxClasses = classNames('recommendation-radio', {
    'recommendation-radio__current-exist': !!recommended_clusters?.find(
      ({ cluster_id }) => cluster_id === current_clusters[0]?.cluster_id
    ),
  })

  const handleRadioChange = (clusterId: string | undefined) => {
    const newValue = clusterId || 'rejected'
    const currentData = JSON.parse(localStorage.getItem(RECOMMENDATION_LOCAL_STORAGE) || '{}')
    currentData[app.store_id] = newValue
    localStorage.setItem(RECOMMENDATION_LOCAL_STORAGE, JSON.stringify(currentData))
    setSelectedCluster(newValue)

    onDecisionCheckboxChange(app.device_type, app.store_id, clusterId ? 'accepted' : 'rejected', clusterId)
  }

  return (
    <div className="decision-cell-renderer">
      {recommended_clusters?.map(({ cluster_id, name }, idx) => {
        return (
          <div className={checkboxClasses} key={idx}>
            <RadioInput
              checked={selectedCluster === cluster_id}
              label={name || 'unknown name'}
              name={`decision-${app.store_id}`}
              onChange={() => handleRadioChange(cluster_id)}
            />
          </div>
        )
      })}
      <div className="recommendation-radio__rejected">
        <RadioInput
          checked={selectedCluster === 'rejected'}
          label="Don't add"
          name={`decision-${app.store_id}`}
          onChange={() => handleRadioChange(undefined)}
        />
      </div>
    </div>
  )
}

export default ClusterDecisionCellRenderer
